<template>
  <v-layout align-center>
    <v-flex sm8>
      <validation-provider v-slot="{errors}"
                           :vid="$attrs.vid"
                           :name="$attrs.vname"
                           :mode="mode"
                           :rules="rules"
                           :bails="bails">
        <v-text-field v-model="innerValue"
                      ref="innerValueId"
                      :error-messages="resolveErrorMessagesHidden(errors)"
                      :error="errors.length > 0"
                      :id="$attrs.vid"
                      :autocomplete="autocomplete"
                      v-bind="$attrs"
                      @blur="getInnerValueStart($attrs.vid)"
                      :dont-fill-mask-blanks="true"
                      :validate-on-blur="true"
                      v-on="$listeners"></v-text-field>
      </validation-provider>
    </v-flex>
    <v-flex sm4>
      <v-select v-model="aborgTxt"
                :items="aborgList"
                item-text="codeName"
                item-value="codeName"
                label="原住民符號"
                hide-no-data
                no-data-text=""
                v-bind="$attrs"
                outline>
      </v-select>
    </v-flex>
  </v-layout>
</template>
<script>
import BaseInputValidate from './BaseInputValidate'
export default {
  name: 'b-name-field',
  extends: BaseInputValidate,
  props: {
    autocomplete: {
      type: String,
      default: 'off'
    }
  },
  data () {
    return {
      aborgTxt: '',
      aborgList: [],
      innerValueStart: 0
    }
  },
  created () {
    this.aborgList = this.getAborgList()
  },
  methods: {
    getAborgList () {
      return this.$store.getters['common/admCodeDetail']({
        codeType: 'ABORG_CODE',
        toObject: false
      })
    },
    getInnerValueStart (id) {
      // let innerValue = this.$refs.innerValueId
      let innerValue = document.getElementById(id)
      this.innerValueStart = innerValue.selectionStart
    }
  },
  watch: {
    aborgTxt: {
      immediate: false,
      handler (newVal, oldVal) {
        if (newVal) {
          if (!this.innerValue) {
            this.innerValue = ''
          }
          if (this.innerValueStart > 0) {
            let t1 = this.innerValue.substring(0, this.innerValueStart)
            let t2 = this.innerValue.substring(this.innerValueStart)
            this.innerValue = t1 + newVal + t2
            this.innerValueStart++
          } else {
            this.innerValue += newVal
          }
          this.defChangeHandler()
          this.$nextTick(() => {
            this.aborgTxt = ''
          })
        }
      }
    }
  }
}
</script>
